// extracted by mini-css-extract-plugin
export default {"facets":"h1v0V","facet-name":"bDpVk","facet-active":"dWQyQ"};